import './App.css';
import Navbar from './components/Navbar';
import { useMeta } from './hooks/useMeta';

function FirmasFerias() {
    useMeta({
        title: 'Firmas y Ferias - MiMadre Universe',
        description: 'Eventos, firmas de libros y ferias literarias donde puedes encontrar a Inmaculada Fuentes y los libros de MiMadre Universe.',
        image: '/portada_mimadre.avif',
        url: 'https://inmaculadafuentes.com/firmas-y-ferias'
    });

    const eventos = [
        {
            fecha: '17 de abril de 2026',
            dia: '17',
            mes: 'ABR',
            titulo: 'Feria del Libro de Elche',
            lugar: 'Elche',
            mapa: 'https://www.google.com/maps/search/Elche',
        },
        {
            fecha: '25 de abril de 2026',
            dia: '25',
            mes: 'ABR',
            titulo: 'Feria del Libro de Callosa',
            lugar: 'Callosa',
            mapa: 'https://www.google.com/maps/search/Callosa+de+Segura',
        },
        {
            fecha: '9 de mayo de 2026',
            dia: '9',
            mes: 'MAY',
            titulo: 'Feria del Libro de Crevillente',
            lugar: 'Crevillente',
            mapa: 'https://www.google.com/maps/search/Crevillente',
        },
    ];

    return (
        <div className="app">
            <Navbar showHomeLink />

            <section className="book-page">
                <div className="book-hero">
                    <h1>Firmas y Ferias</h1>
                    <p>Eventos y encuentros literarios donde nos puedes encontrar</p>
                </div>

                <div className="book-section">
                    <h2>Próximos Eventos</h2>
                    <div className="eventos-grid">
                        {eventos.map((evento, index) => (
                            <div className="evento-card" key={index}>
                                <div className="evento-fecha">
                                    <span className="evento-dia">{evento.dia}</span>
                                    <span className="evento-mes">{evento.mes}</span>
                                </div>
                                <div className="evento-info">
                                    <h3>{evento.titulo}</h3>
                                    <a href={evento.mapa} target="_blank" rel="noopener noreferrer" className="evento-ubicacion">📍 {evento.lugar}</a>
                                    <p className="evento-fecha-completa">📅 {evento.fecha}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default FirmasFerias;